import React, { useState, useContext } from "react";
import { VehiculosContext } from "../../context/VehiculosContext";
import { Tabs, Tab, Modal } from "react-bootstrap";

import iconoCerrar from "../../assets/img/icono-cerrar.svg";
import tabSeguridad from "../../assets/img/tabs-seguridad.png";
import tabConfort from "../../assets/img/tabs-confort.png";

import seguridad1 from "../../assets/img/landing-pulse/tabs/seguridad1.png";
import confort1 from "../../assets/img/landing-pulse/tabs/confort1.png";

import seguridad2 from "../../assets/img/landing-pulse/tabs/seguridad2.png";
import confort2 from "../../assets/img/landing-pulse/tabs/confort2.png";
import { FichaTecnica } from "./FichaTecnica";

const ModalFichaTecnica = ({ show, handleClose }) => {
  const { vehiculos, marcaLanding, modeloLanding, arrayVehiculos } = useContext(VehiculosContext);

  return (
    <Modal show={show} onHide={handleClose} centered id="modal-resumen-vehiculo">
      <Modal.Header>
        <h5 className="titulo-modal">Resumen del vehículo</h5>
        <button className="boton-cerrar-modal" onClick={handleClose}>
          <img src={iconoCerrar} alt="" />
        </button>
      </Modal.Header>

      <Modal.Body>
        <h4 className="titulo-secundario-modal">
          CRONOS MY23 <span id="subtituloFicha">{modeloLanding} {vehiculos}</span>
        </h4>
        <FichaTecnica arrayVehiculos={arrayVehiculos} vehiculos={vehiculos} />
      </Modal.Body>
    </Modal>
  );
};

export default ModalFichaTecnica;
